import {sendMobileAnalyticsPerSession} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';

import {TYP_REVIEW_POPUP} from 'constants/analytics/events/typ';
import {REVIEWS_POPUPS} from 'constants/popupNames';
import {ReviewPopupsPopupType, ReviewPopupsType} from 'types/reviewPopupsTypes';

import {initBizrate} from '../bizrate/bizrate';
import {initReseller} from '../reseller/reseller';
import {initSiteJabber} from '../siteJabber/siteJabber';

const initTrustPilot = () => null;

const popupConstants = {
    [REVIEWS_POPUPS.BIZRATE]: {action: initBizrate, eventLabel: 'Bizrate'},
    [REVIEWS_POPUPS.RESELLER]: {action: initReseller, eventLabel: 'Reseller'},
    [REVIEWS_POPUPS.SITEJABBER]: {action: initSiteJabber, eventLabel: 'Sitejabber'},
    [REVIEWS_POPUPS.TRUST_PILOT]: {action: initTrustPilot, eventLabel: 'Trust pilot'},
};

/**
 * Initialize review popup if we have it
 */
export function initPopup(
    additionalPopup: ReviewPopupsPopupType,
    successPageReviewPopups: ReviewPopupsType,
    setIsPopupLoading?: (isLoading: boolean) => void,
) {
    if (Object.keys(popupConstants).includes(additionalPopup)) {
        popupConstants[additionalPopup as keyof typeof popupConstants].action(
            successPageReviewPopups,
            setIsPopupLoading,
        );
        sendMobileAnalyticsPerSession({
            event: TYP_REVIEW_POPUP,
            isInteraction: false,
            label: popupConstants[additionalPopup as keyof typeof popupConstants].eventLabel,
        });
    }
}
